export const initialState = { accessToken: undefined, user: undefined };
